import { toast } from 'sonner';

export function publicSongUrl(slug) {
  return `${window.location.origin}/song/${slug}`;
}

export async function shareSong({ slug, title, creator }) {
  const url = publicSongUrl(slug);
  const text = `🎧 Écoute "${title}"${creator ? ` par ${creator}` : ''} sur MyMusic IA — Le studio de ton imagination`;
  if (navigator.share) {
    try {
      await navigator.share({ title: `MyMusic IA — ${title}`, text, url });
      return;
    } catch {
      /* user cancelled or unsupported -> fallback */
    }
  }
  const wa = `https://api.whatsapp.com/send?text=${encodeURIComponent(`${text}\n${url}`)}`;
  window.open(wa, '_blank', 'noopener');
}

export async function copySongLink(slug) {
  try {
    await navigator.clipboard.writeText(publicSongUrl(slug));
    toast.success('Lien copié !');
  } catch {
    toast.error('Impossible de copier le lien');
  }
}
